import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '.';
import { IApplicationContext } from '../types/ICustomContextParams';
import {
  fetchGetSpecialistsCatalog,
  IGetSpecialistsCatalogResponse,
} from '../repositories/demand/v2/get-specialists-catalog';
import { IGeoExV4Schema } from '../repositories/demand/entities/geo/GeoExV4Schema';
import { REALTORS_ON_PAGE } from '../constants/pagination';

export type TSpecialistsApiEndpoints = keyof typeof specialistsApi.endpoints;
export let specialistsApi: ReturnType<typeof createSpecialistsApi>;

export const createSpecialistsApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'specialistsApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getSpecialists: builder.query<
        IGetSpecialistsCatalogResponse,
        {
          geo: IGeoExV4Schema;
          pageNumber?: number;
        }
      >({
        query: rawParameters => {
          const { geo, pageNumber = 1 } = rawParameters;
          const parameters = {
            geo,
            limit: REALTORS_ON_PAGE,
            offset: (pageNumber - 1) * REALTORS_ON_PAGE,
          };

          return {
            parameters,
            fetchFunction: fetchGetSpecialistsCatalog,
            loggerInfo: {
              description: 'Получение списка риелторов',
              // TODO: падение этой ручки блокирует флоу, но, кажется, не должно этого происходить
              degradation: 'Критическая ошибка. Видит экран "Произошла ошибка"',
            },
          };
        },
      }),
    }),
  });

  specialistsApi = newApi;

  return newApi;
};
